// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".ns-animate-height[data-v-d7e78cec]{overflow:hidden;transition:max-height .225s ease}", ""]);
// Exports
module.exports = exports;
